import Coverage from "@/modules/common/common/models/MID/Coverage"

export class PetRaterAdditionalCoverage extends Coverage {
  selected: boolean | undefined
  rangeValue: number | undefined

  constructor(data: any = {}) {
    super(data)
    this.selected = data.selected
    this.rangeValue = data.rangeValue
  }
}
